import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=71a0dc46&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Paginate.vue?vue&type=style&index=0&id=71a0dc46&prod&lang=css&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71a0dc46",
  "e277deb0"
  
)

export default component.exports